import Swiper, {Navigation, Pagination, Autoplay} from 'swiper'
import * as Util from 'util'
import Network from '../../../client/network'
import Ui from '../../../client/client-ui'
import {Define} from '../../../define'
import AwesomeNotifications from 'awesome-notifications'

export default class Shop
{
	static init()
	{
		$('#_recruit').html($('#tab_recruit').html())
	}

	static toggle_bookmark(shop, node, guest)
	{
		//FIXME - ログインを促すべき
		if(guest)
		{
			location.href = '/register'
			return
		}

		const bookmarked = $(node).attr('src') === '/image/shop-bookmarked.png'

		Ui.post('/bookmark/', {
			shop : shop,
			state: bookmarked ? 'off' : 'on',
		}, (success) =>
		{
			if(success)
			{
				if(bookmarked)
				{
					$(node).removeClass('_bookmark')
					$(node).attr('src', '/image/shop-bookmark.png')
				}
				else
				{
					$(node).addClass('_bookmark')
					$(node).attr('src', '/image/shop-bookmarked.png')
				}
			}
		})
	}

	static open_chat(identifier, shop)
	{
		$('nav').slideUp()
		$(document.body).addClass('no-scroll')

		$('#modal-video iframe').attr('src', Util.format(Define.shop.chat_url, identifier))
		$('#modal-video h4').text(shop)

		$('#modal-video').height($(window).height())
		$('#modal-video').fadeIn()

		$(window).on('resize', () =>
		{
			$('#modal-video').height($(window).height())
		})
	}

	static close_chat()
	{
		if(!confirm('通話を停止しますか？')) return
		$(document.body).removeClass('no-scroll')

		$('#modal-video').fadeOut()
		$('#modal-video iframe').attr('src', '')
	}

	static reservation_coupon()
	{
		const coupon = $('#tab_coupon').clone()
		coupon.attr('id', null)

		coupon.removeClass('hidden')
		coupon.css('display', 'block')

		coupon.addClass('_select')

		const header = `<h2 class="text-center">クーポンを選択してください</h2>`
		const notification = new AwesomeNotifications()

		// noinspection JSUnresolvedFunction
		notification.modal(header + coupon[0].outerHTML)
	}

	static _swiper_ready = false

	static tab(section)
	{
		$('#nav a').removeClass('_tab_active')
		$('#nav_' + section).addClass('_tab_active')

		$('#tab section').fadeOut(0)
		$('#tab_' + section).fadeIn(300)

		if(section !== 'shop')
		{
			const data = new FormData()

			data.append('_action', 'statistic')
			data.append('section', section)

			Network.post(location.pathname, data, null, false)
		}
		else if(!this._swiper_ready)
		{
			this._swiper_ready = true
			Swiper.use([Navigation, Pagination, Autoplay])

			new Swiper('#_coupon', {
				slidesPerView: 1,
				autoplay     : {
					disableOnInteraction: false,
					delay               : 5000,
				},
				autoHeight   : true,
				loop         : true,
				pagination   : {
					el  : '.swiper-pagination',
					type: 'bullets',
				},
				navigation   : {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})

			new Swiper('#_staff', {
				slidesPerView: 1,
				autoplay     : {
					disableOnInteraction: false,
					delay               : 5000,
				},
				autoHeight   : true,
				loop         : true,
				pagination   : {
					el  : '.swiper-pagination',
					type: 'bullets',
				},
				navigation   : {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})
		}
	}

	static phone(shop_identifier)
	{
		const data = new FormData()

		data.append('_action', 'phone')
		data.append('shop', shop_identifier)

		App.common.Network.post(location.pathname, data, null, false)
	}

	static load_tab(hash)
	{
		hash = hash.replace(/^#/, '')
		if(!hash) hash = 'shop'

		this.tab(hash)
	}
}
